// Dates officielles Zone B (Académie d'Orléans-Tours) — année scolaire 2026-2027
// Convention Éducation nationale : départ après la classe, reprise le matin de la date "reprise".
export const VACANCES = [
  { id: "toussaint", name: "Vacances de la Toussaint", short: "Toussaint", start: "2026-10-17", reprise: "2026-11-02" },
  { id: "noel", name: "Vacances de Noël", short: "Noël", start: "2026-12-19", reprise: "2027-01-04" },
  { id: "hiver", name: "Vacances d'hiver", short: "Hiver", start: "2027-02-20", reprise: "2027-03-08" },
  { id: "printemps", name: "Vacances de printemps", short: "Printemps", start: "2027-04-17", reprise: "2027-05-03" },
  { id: "ete", name: "Vacances d'été", short: "Été", start: "2027-07-03", reprise: null },
];

export const JOURS_FERIES = [
  { date: "2026-11-01", name: "Toussaint" },
  { date: "2026-11-11", name: "Armistice 1918" },
  { date: "2026-12-25", name: "Noël" },
  { date: "2027-01-01", name: "Jour de l'an" },
  { date: "2027-03-29", name: "Lundi de Pâques" },
  { date: "2027-05-01", name: "Fête du Travail" },
  { date: "2027-05-06", name: "Ascension" },
  { date: "2027-05-08", name: "Victoire 1945" },
  { date: "2027-05-17", name: "Lundi de Pentecôte" },
  { date: "2027-07-14", name: "Fête nationale" },
];

export const DATES_SCOLAIRES = [
  { date: "2026-09-01", name: "Rentrée scolaire" },
  { date: "2027-07-03", name: "Fin de l'année scolaire" },
];

export function vacanceForDay(dayIso) {
  return VACANCES.find((v) => dayIso >= v.start && (v.reprise ? dayIso < v.reprise : true)) || null;
}
